import { StatutoryRepresentativeConsent } from '@dreryk/egabinet-referral-frontend-api';

import { BindingCreator } from '@dreryk/react-common';
import { RadioGroup, RadioGroupItem } from '@dreryk/react-components';

import { referralToPsychiatricHospitalTranslationKeys } from '../../../translations';

const STATUTORY_REPRESENTATIVE_CONTENT_FIELD_NAME = 'statutoryRepresentativeConsent';

type StatutoryRepresentativeConsentFormBeanPart = {
   [STATUTORY_REPRESENTATIVE_CONTENT_FIELD_NAME]: StatutoryRepresentativeConsent;
};

type StatutoryRepresentativeConsentRadioGroupProps = {
   readonly register: BindingCreator<
      StatutoryRepresentativeConsentFormBeanPart,
      typeof STATUTORY_REPRESENTATIVE_CONTENT_FIELD_NAME
   >;
};

const items: RadioGroupItem<StatutoryRepresentativeConsent>[] = [
   {
      id: 'NOT_APPLICABLE',
      label: referralToPsychiatricHospitalTranslationKeys.notApplicable,
   },
   {
      id: 'WITH_CONSENT',
      label: referralToPsychiatricHospitalTranslationKeys.yes,
   },
   {
      id: 'WITHOUT_CONSENT',
      label: referralToPsychiatricHospitalTranslationKeys.no,
   },
];

export const StatutoryRepresentativeConsentRadioGroup = (
   props: StatutoryRepresentativeConsentRadioGroupProps
): JSX.Element => {
   return (
      <RadioGroup
         testId={'statutoryRepresentativeConsent'}
         items={items}
         controller={props.register(STATUTORY_REPRESENTATIVE_CONTENT_FIELD_NAME, { required: true })}
         label={referralToPsychiatricHospitalTranslationKeys.statutoryRepresentativeConsent}
         horizontal
      />
   );
};
